
import React from 'react';
import EstimatesList from '@/components/estimates/EstimatesList';

const EstimatesPage = () => {
  return <EstimatesList />;
};

export default EstimatesPage;

